import getSlug from 'speakingurl'

export function getOrganizationDomain() {
  return window.location.hostname.split('.')[0].split('__')[0]
}

export function getOtherOrganizationAppURL(domain) {
  return `${window.location.origin.replace(
    getOrganizationDomain(),
    domain
  )}/app`
}

export function getRootURL() {
  return window.location.origin.replace(`${getOrganizationDomain()}.`, '')
}

export function createSlug(label) {
  return getSlug(label, { maintainCase: true })
}

export function getNoteShareLink(
  { apiEndpoint },
  { notePublicShareToken, noteTitle }
) {
  return `${apiEndpoint}/s/${notePublicShareToken}/${createSlug(noteTitle)}`
}

export function isDetachedMode() {
  return window.location.pathname.includes('detached')
}
